/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import Dialog from '@mui/material/Dialog';
import { Dialog } from '@material-ui/core';
import routing from '../../../service/routes/routing';
import MyButton from '../../../components/button/MyButton';
import TableProduct from '../../../components/tables/creditCard/TableCreditCard';
import Checkout from './creditCard/new/Checkout';
import styles from '../../../styles/Layout.module.css';
import api from '../../../service/axios/api';
import Loading from '../../../components/loading/Loading';

function NewCreditCard() {
  const history = useHistory();
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [itens, setItens] = useState({
    label: '25',
    value: 25,
  });
  const [openModal, setOpenModal] = useState(false);

  const [status, setStatus] = useState({ label: '', value: '' });
  const search = useRef(null);

  const { t } = useTranslation();

  const find = () => {
    setLoading(true);
    const cancel = new AbortController();
    api.product
      .getCard(status.value, search.current.value, itens.value, page, cancel)
      .then(card => {
        setTotalPages(card.pages);
        setProducts(card.docs);
        setLoading(false);
      })
      .catch(error => {
        console.log(error);
        setLoading(false);
      });
  };
  useEffect(() => {
    find();
  }, [itens, page, status]);
  return (
    <>
      <Loading open={loading} msg="Buscando cartões..." />
      <div className="col-sm-12" style={{ marginTop: 50 }}>
        <p
          className={styles.textMenu}
          onKeyDown={() => history.push(routing.newProduct)}
          onClick={() => history.push(routing.newProduct)}
        >
          Menu Inicial
        </p>
        <div
          className="col-sm-12"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h4 className={styles.textTitle}>{t('Product.creditCard.label1')}</h4>
          <MyButton
            style={{ marginRight: 50 }}
            label={t('Product.creditCard.new')}
            onClick={() => setOpenModal(true)}
          />
        </div>
        <div>
          <TableProduct
            products={products}
            totalPages={totalPages}
            page={page}
            setPage={setPage}
            itens={itens}
            setItens={setItens}
            setStatus={setStatus}
            search={search}
            find={find}
          />
        </div>
      </div>
      <Dialog
        onClose={() => setOpenModal(false)}
        open={openModal}
        // width={1192}
        // height={776}
        fullWidth
        maxWidth="lg"
      >
        <Checkout setOpenModal={setOpenModal} />
      </Dialog>
    </>
  );
}

export default NewCreditCard;
